import { render, staticRenderFns } from "./totalPedido.vue?vue&type=template&id=8be400b0&scoped=true&"
import script from "./totalPedido.vue?vue&type=script&lang=js&"
export * from "./totalPedido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8be400b0",
  null
  
)

export default component.exports